import { z } from 'zod';
/**
 * Zahlungen auf Ausgangsrechnungen (KON-152). Eine Zahlung wird nur angelegt, nie geändert oder gelöscht. Ein Irrtum wird mit einer Gegenzahlung zurückgenommen
 * (negativer Betrag, Verweis auf die Ursprungszahlung). Der Zahlungsstand einer Rechnung wird aus den Zuordnungen errechnet und nirgends gespeichert.
 */
export const PAYMENT_METHODS = ['bank_transfer', 'sepa_debit', 'cash', 'card', 'paypal', 'voucher', 'offset'];
export const PAYMENT_METHOD_LABELS = {
    bank_transfer: 'Überweisung',
    sepa_debit: 'Lastschrift',
    cash: 'Bar',
    card: 'Karte',
    paypal: 'PayPal',
    voucher: 'Gutschein',
    offset: 'Verrechnung',
};
/** Von Hand wählbar. „Verrechnung“ entsteht nur automatisch, wenn eine Stornorechnung oder Gutschrift eine Rechnung ausgleicht. */
export const MANUAL_PAYMENT_METHODS = PAYMENT_METHODS.filter((m) => m !== 'offset');
export const PAYMENT_STATUSES = ['open', 'partial', 'paid', 'cancelled'];
export const PAYMENT_STATUS_LABELS = { open: 'Offen', partial: 'Teilweise bezahlt', paid: 'Bezahlt', cancelled: 'Storniert' };
/** Filter der Liste: „offen“ heißt noch nicht vollständig bezahlt, „überfällig“ zusätzlich über das Fälligkeitsdatum hinaus */
export const PAYMENT_FILTERS = ['open', 'overdue', 'paid'];
export const PAYMENT_FILTER_LABELS = { open: 'Offen', overdue: 'Überfällig', paid: 'Bezahlt' };
const optionalText = (max) => z.string().trim().max(max).nullable().optional().transform((v) => (v ? v : null));
export const recordPaymentInput = z
    .object({
    amountCents: z.number('Bitte einen Betrag angeben').int('Betrag in Cent').min(1, 'Der Betrag muss größer als 0 sein').max(1_000_000_000_00),
    /** Skonto, das der Kunde abgezogen hat. Es mindert den offenen Betrag, ist aber kein Geldeingang. */
    discountCents: z.number().int('Betrag in Cent').min(0, 'Skonto nicht negativ').max(1_000_000_000_00).default(0),
    paidOn: z.iso.date('Bitte ein Datum angeben'),
    method: z.enum(MANUAL_PAYMENT_METHODS, 'Bitte eine Zahlungsart wählen'),
    reference: optionalText(200),
    note: optionalText(1000),
})
    .strict();
export const reversePaymentInput = z.object({ reason: z.string().trim().min(1, 'Bitte einen Grund angeben').max(1000) }).strict();
/** Zahlungsverhalten eines Kunden, abgeleitet aus seinen eigenen Rechnungen (keine Auskunftei) */
export const PAYMENT_BEHAVIORS = ['none', 'good', 'attention', 'critical'];
export const PAYMENT_BEHAVIOR_LABELS = { none: 'Noch keine Erfahrung', good: 'Zahlt zuverlässig', attention: 'Gelegentlich verspätet', critical: 'Zahlt oft zu spät' };
//# sourceMappingURL=payments.js.map